module.exports = __webpack_public_path__ + "static/media/1.เอกสารคำร้องขอกู้ยืมเงินทุนประกอบอาชีพ (รายบุคคล).10912b04.pdf";